var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"material-template-page"}},[_c('div',{staticClass:"header"},[_c('span',{domProps:{"textContent":_vm._s(_vm.identities[_vm.identityId])}})]),(_vm.currentIdentity)?_c('materials-of-indentity',{attrs:{"active-identity":_vm.currentIdentity,"have-id-photo":_vm.haveIdPhoto,"show-sample-and-template":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }